var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{staticClass:"form-control",domProps:{"value":_vm.value},on:{"change":_vm.handleInput}},[(!_vm.required)?_c('option'):_vm._e(),_vm._l((_vm.options),function(option,n){return _c('option',{key:n,attrs:{"disabled":option.disabled},domProps:{"value":option[_vm.valueField]}},[_vm._v(" "+_vm._s(option[_vm.textField])+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }